// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../cache-deps/virtual-store/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-wrapper[data-v-fc712194]{border-color:rgba(211,214,221,var(--tw-border-opacity));padding-top:.25rem;padding-bottom:.25rem}.focused-border[data-v-fc712194],.search-wrapper[data-v-fc712194]{border-width:1px;--tw-border-opacity:1}.focused-border[data-v-fc712194]{border-color:rgba(18,131,218,var(--tw-border-opacity))}.custom-border[data-v-fc712194]{width:1px;height:24px}", ""]);
// Exports
module.exports = exports;
